// extracted by mini-css-extract-plugin
export default {"container":"styles_container__kuj+u","propertyType":"styles_propertyType__Y-qlg","propertyInput":"styles_propertyInput__xL6bF"};